var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"form-control max-w-full w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid rounded-xl transition ease-in-out m-0 resize-y focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none",class:{
        'border-box-stroke': !_vm.error,
        'border-red-600': _vm.error,
    },attrs:{"rows":"3","placeholder":_vm.getPlaceHolder,"disabled":_vm.disabled || _vm.formAlreadySubmitted},domProps:{"value":_vm.getValue},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }